__turbopack_context__.v({
  "className": "noEnxa_className",
  "variable": "noEnxa_variable",
});
